import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/poster.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/step_background_1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/step_background_2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/step_background_3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/step_background_4.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/white_circle_bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/global/breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/global/faqs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/global/logo-slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/global/reasons-benefits.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/global/trusted.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/landing/BusinessHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/landing/Hero.tsx");
